import api from '../utils/api'

interface AffiliateData {
  // Personal Information
  fullName: string
  email: string
  phone: string
  alternatePhone?: string
  dateOfBirth?: string
  gender?: string
  
  // Social Media Information
  website?: string
  instagram?: string
  youtube?: string
  facebook?: string
  twitter?: string
  
  // Affiliate Information
  referralCode: string
  commissionRate: string
  category?: string
  experience?: string
  
  // Additional Information
  status: string
}

class AffiliateService {
  // Create new affiliate
  createAffiliate(affiliateData: AffiliateData) {
    return api.post('/create-affiliate', affiliateData)
  }

  // Get all affiliates
  getAffiliates(params?: any) {
    return api.get('/get-affiliates', { params })
  }

  // Get affiliate by ID
  getAffiliateById(id: string) {
    return api.get(`/get-affiliate/${id}`)
  }

  // Update affiliate
  updateAffiliate(id: string, affiliateData: Partial<AffiliateData>) {
    return api.put(`/update-affiliate/${id}`, affiliateData)
  }

  // Delete affiliate
  deleteAffiliate(id: string) {
    return api.delete(`/delete-affiliate/${id}`)
  }

  // Update affiliate status
  updateAffiliateStatus(id: string, status: string) {
    return api.patch(`/update-affiliate-status/${id}`, { status })
  }

  // Get affiliate by referral code
  getAffiliateByReferralCode(referralCode: string) {
    return api.get(`/get-affiliate-by-code/${referralCode}`)
  }

  // Get affiliate statistics
  getAffiliateStats(id?: string) {
    return api.get('/get-affiliate-stats', { params: { id } })
  }

  // Get users who registered with a referral (ADMIN view)
  // Backend route should return { users, pagination }
  getReferredUsers(params?: any) {
    return api.get('/get-referred-users', { params })
  }

  // Get affiliate commission details (summary + referred users)
  getAffiliateCommissionDetails(params: { referralCode?: string; affiliateId?: string }) {
    return api.get('/get-affiliate-commission-details', { params })
  }

  // Settlement statement list
  getAffiliateSettlements(params?: any) {
    return api.get('/get-affiliate-settlements', { params })
  }

  // Create a settlement entry
  createAffiliateSettlement(body: any) {
    return api.post('/create-affiliate-settlement', body)
  }

  getAffiliateUsers() {
    // Get referral code of logged-in affiliate from localStorage
    const referralCode = localStorage.getItem('referralCode-affiliate')
    console.log(referralCode)
    // Send GET request with referralCode as query param
    return api.get('/affiliate/users', {
      params: { referralCode },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token-affiliate')}`
      }
    })
  }

  getAccStPanel() {
    // Get referral code of logged-in affiliate from localStorage
    const referralCode = localStorage.getItem('referralCode-affiliate')
    console.log(referralCode)
    // Send GET request with referralCode as query param
    return api.get('/accountStPanel', {
      params: { referralCode },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token-affiliate')}`
      }
    })
  }


  
}

const affiliateService = new AffiliateService()
export default affiliateService
